import React, { Component } from 'react';
import { Tag } from 'antd';
import { TagProps } from 'antd/lib/tag';

import styles from './index.less';

export interface ITagProps {
  name: string;
  label?: string;
  value: string | number;
  isSelected?: boolean;
  defaultSort?: string;
}
const defaultProps = {
  inline: false,
  dataSource: [],
};
interface IProps {
  inline: boolean;
  dataSource: ITagProps[];
  onChange?: (v: Array<string | number>) => void;
}

export default class Tags extends Component<IProps> {
  static defaultProps = defaultProps;
  render() {
    const { dataSource, inline } = this.props;
    return (
      <div style={{ display: inline ? 'inline-block' : 'block' }}>
        {dataSource &&
          !!dataSource.length &&
          dataSource.map(({ label, value, name, isSelected, ...props }) => (
            <Tag
              closable
              key={value}
              className={styles.tag}
              {...props}
              onClose={this.handleClose(value)}
            >
              {label || name}
            </Tag>
          ))}
      </div>
    );
  }
  handleClose = (v: string | number) => {
    return () => {
      const { dataSource, onChange } = this.props;

      onChange && onChange(dataSource.filter((c) => c.value !== v).map((c) => c.value));
    };
  };
}
